/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Box, Heading } from 'grommet';

const TeamsPageEmptyState: React.FC = () => (
  <Box align="center" flex="grow" justify="center">
    <Heading color="night90" level="4" size="medium">
      No teams have been set up
    </Heading>
  </Box>
);

export default TeamsPageEmptyState;
